<footer>
  <div class="container text-center py-2">
    <p class="mb-0">&copy; {{ currentYear }} All rights reserved |
      Designed and Developed by RITA {{APP_VERSION}}</p>
  </div>
</footer>
